export { default } from "../../../common/expertise/CatalogExpertiseFilterSection";
